// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseFragmentDoc } from './fragments/loginResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginWithFacebookDocument = gql`
    mutation loginWithFacebook($credentials: CustomerRegistrationByFacebookInput!, $locale: Locale!, $isConsultant: Boolean!) {
  loginWithFacebook(credentials: $credentials) {
    ...loginResponse
  }
}
    ${LoginResponseFragmentDoc}`;

export function useLoginWithFacebookMutation() {
  return Urql.useMutation<SchemaTypes.LoginWithFacebookMutation, SchemaTypes.LoginWithFacebookMutationVariables>(LoginWithFacebookDocument);
};